const state = {
  loggedIn: false,
  email: undefined,
  username: undefined
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  setAuth({ state, commit }, user_data) {
    commit('setAuthState', user_data);
  }
};

const mutations = {
  setAuthState(state, { authenticated, email, username }) {
    state.loggedIn = authenticated;
    state.email = email;
    state.username = username;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
